import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dropleft" }
const _hoisted_2 = { class: "dropdown-menu" }
const _hoisted_3 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_4 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_7 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "dropdown-divider pt-0"
}
const _hoisted_10 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_11 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_12 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_15 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_18 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_21 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_24 = {
  key: 0,
  class: "cd-user-menu__list-item"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  class: "dropdown-item pt-0",
  href: "#"
}
const _hoisted_27 = { class: "cd-user-menu__list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("button", {
      type: "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      style: {"width":"100%","height":"33px","position":"absolute","z-index":"1","border":"none","background":"transparent"}
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        (_ctx.PROFILE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                href: _ctx.PROFILE,
                target: "_blank"
              }, _toDisplayString(_ctx.$t("userSideMenuV1.myProfile")), 9, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("a", _hoisted_6, [
        (_ctx.NOTIFICATIONS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("a", { href: _ctx.NOTIFICATIONS }, _toDisplayString(_ctx.$t("userSideMenuV1.notifications")), 9, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.cdOrganisationAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("a", _hoisted_10, [
        (_ctx.cdOrganisationAvailable)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dropdown-header",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, _toDisplayString(_ctx.$t("userSideMenuV1.switchTo")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("a", _hoisted_11, [
        (_ctx.cdUserAvailable && _ctx.cdOrganisationAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherTenants, (tenant) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: tenant.tenantId,
                  class: "dropdown-item pl-5",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.switchToTenant(tenant.tenantId)), ["prevent"])
                }, _toDisplayString(tenant.tenantShortName), 9, _hoisted_13))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
      _createElementVNode("a", _hoisted_14, [
        (_ctx.DOCS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("a", { href: _ctx.DOCS }, _toDisplayString(_ctx.$t("userSideMenuV1.help")), 9, _hoisted_16)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("a", _hoisted_17, [
        (_ctx.SUPPORT_MAILTO)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("a", {
                href: 'mailto://' + _ctx.SUPPORT_MAILTO
              }, _toDisplayString(_ctx.$t("userSideMenuV1.support")), 9, _hoisted_19)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("a", _hoisted_20, [
        (_ctx.SUGGESTIONS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("a", { href: _ctx.SUGGESTIONS }, _toDisplayString(_ctx.$t("userSideMenuV1.haveYourSay")), 9, _hoisted_22)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("a", _hoisted_23, [
        (_ctx.POLICIES)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("a", { href: _ctx.POLICIES }, _toDisplayString(_ctx.$t("userSideMenuV1.legalPrivacyCookies")), 9, _hoisted_25)
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
      _createElementVNode("a", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
            _createTextVNode(_toDisplayString(_ctx.$t("userSideMenuV1.logout")), 1)
          ])
        ])
      ])
    ])
  ]))
}